export default __webpack_public_path__ + "static/media/envelope.2bb82e98.svg";